import * as Vue from 'vue';
import UniqueId from 'vue-unique-id';
import * as VueRouter from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2';

import OptionsScreen from './Pages/OptionsScreen';
import Stats from './Pages/Stats';
import Settings from './Pages/Settings';
import Performance from './Pages/Performance';
import AdvancedSettings from './Pages/AdvancedSettings';
import License from './Pages/License';

import EventBus from "./Utilities/EventBus";

const app = Vue.createApp({});

app.use(UniqueId);
app.use(VueSweetalert2);

let {trans, ...ezcache} = window.ezcache;

app.config.compilerOptions.whitespace = 'preserve';
app.config.globalProperties.$window = window;
app.config.globalProperties.$eventBus = EventBus;
app.config.globalProperties.$wp = {
    ...ezcache,
    trans(key) {
        return trans[key] ? trans[key] : `__${key}__`;
    }
};

app.component('ezc-options', OptionsScreen);

app.mixin({
    methods: {
        toast(text, type='success') {
            return this.$swal({
                icon: type,
                position: 'top',
                type: type,
                text: text,
                timer: 2000,
                toast: true,
                showCancelButton: false,
                showCloseButton: false,
                showConfirmButton: false
            });
        },
        confirm(title, text, type = 'primary', confirmButtonText = null) {
            const buttonColors = {
                primary: '#1A70A6',
                danger: '#C4243A',
                warning: '#FDC310',
            };
            if(!buttonColors[type]) {
                type = 'primary';
            }

            return this.$swal({
                text: text,
                title: title,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: (confirmButtonText || this.$wp.trans('confirm')),
                confirmButtonColor: buttonColors[type],
                cancelButtonText: this.$wp.trans('cancel'),
                reverseButtons: this.$wp.trans('is_rtl'),
                focusCancel: true
            });
        }
    }
});

const routes = [
    { path: '/', component: Stats },
    { path: '/settings', component: Settings },
    { path: '/performance', component: Performance },
    { path: '/advanced', component: AdvancedSettings },
    { path: '/license', component: License },
];
const router = VueRouter.createRouter({
  history: VueRouter.createWebHashHistory(),
  routes
});

app.use(router);
app.mount('#ezcache-options');
